import cx from 'classnames';
import { CanvasNavigation } from 'themes/canvas/components/Navigation/CanvasNavigation';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import energyStyles from '../EnergyLayout/EnergyLayout.module.css';
import canvasStyles from 'themes/canvas/components/CanvasLayout/CanvasLayout.module.css';

interface TProps {
  children: React.ReactNode;
}

const EnergyMinimalLayout = ({ children }: TProps) => {
  const { theme } = useGGTheme();
  const paletteName = theme?.palette.name;

  return (
    <div
      className={cx(canvasStyles.canvas, canvasStyles.minimalLayout, {
        [energyStyles.energy]: paletteName === 'Energy',
        [canvasStyles.energyPalette]: paletteName === 'Energy',
        [canvasStyles.sandPalette]: paletteName === 'Sand',
      })}
    >
      <div className={canvasStyles.layout}>
        <CanvasNavigation />
        <div className={canvasStyles.minimalLayoutContent}>{children}</div>
      </div>
    </div>
  );
};

export { EnergyMinimalLayout };
